import React from 'react'
import { blue } from "@mui/material/colors";
import RegularButton from "components/CustomButtons/Button";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import Edit from "@mui/icons-material/Edit";

const configTable = [
  {
    Header: "Nombre",
    accessor: "name",
    filterable: true,
    filterMethod: (filter, row) => row.name?.toLowerCase().includes(filter.value.toLowerCase())
  },
  {
    Header: "Acciones",
    accessor: "id",
    sortable: false,
    filterable: false,
    Cell: ({original}) => {
      const hist = useHistory()
      const handleChangePage = (page) => {
        const newDirection = page ? page : "/admin/nuevo_marca";
        hist.push(newDirection);
      };
      return (
      <div className="actions-right">
          <RegularButton
            justIcon
            round
            color="transparent"
            tooltip="Editar"
            onClick={() =>
              handleChangePage(`/admin/editar_marca/editar/${original?.id}`)
            }

          >
            <Edit style={{color: blue[800]}}/>
          </RegularButton>
      </div>
    )},
  }
];

export { configTable };
